/**
 * Execution (Transmission Detail) — Types & Initial State
 *
 * Matches the execution API: GET /execution/{executionArn}
 * Response shape mirrors file detail API (same statusMap format).
 */

/** A single event within a lifecycle stage. */
export interface ExecutionStatusEvent {
  status: string;
  state: string;
  timestamp: number | null;
}

/** Detail for a lifecycle stage in execution statusMap. */
export interface ExecutionStatusDetail {
  enteredAt: number | null;
  exitedAt: number | null;
  latencyMs: number | null;
  state: string;
  paymentStatus: string | null;
  errorCode: string | null;
  errorMessage: string | null;
  statuses: ExecutionStatusEvent[];
}

/** Full execution detail returned by GET /execution/{executionArn}. */
export interface ExecutionDetailData {
  fileName: string | null;
  bank: string | null;
  direction: string | null;
  messageType: string | null;
  dataSource: string | null;
  beaconTransmissionState: string | null;
  beaconTransmissionStatus: string | null;
  createdAt: number | null;
  updatedAt: number | null;
  totalE2ELatencyMs: number | null;
  statusMap: Record<string, ExecutionStatusDetail>;
}

/** Redux slice state for execution detail. */
export interface ExecutionState {
  data: ExecutionDetailData | null;
  loading: boolean;
  error: string | null;
  currentRequestId: string | null;
}

export const executionInitialState: ExecutionState = {
  data: null,
  loading: false,
  error: null,
  currentRequestId: null,
};
